

























































import { Component, Prop, Vue } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";
import { mapGetters } from "vuex";
import { UserMetaKeys } from "@/data/enums/users";
import store from "@/store";

@Component({
  components: {
    "contract-categories-provider": () =>
      import(
        "@/components/app/global/contractCategories/categoriesProvider.vue"
      )
  },
  computed: {
    ...mapGetters({
      hasDelegatedProducts: "auth/client/hasDelegatedProducts"
    })
  }
})
export default class ClientContractProducts extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];

  // Data

  public form = this.initForm();
  public hasDelegatedProducts!: boolean;

  // Computed

  public get defaultRoutes(): IMenuRoute[] {
    return [
      {
        label: this.$t("_.all_products_and_services"),
        to: {
          name: "client__products"
        }
      },
      {
        label: this.$t("_.subscriptions"),
        to: {
          name: "client__subscriptions"
        }
      },
      {
        label: this.$t("_.one_time_purchases"),
        to: {
          name: "client__oneTimePurchases"
        }
      }
    ];
  }

  // Methods

  public initForm() {
    return {
      exclude_delegated: parseInt(
        store?.getters["user/meta"](
          UserMetaKeys.UI_PRODUCTS_EXCLUDE_DELEGATES
        ) ?? `0`
      )
    };
  }

  public onToggleDelegated(val: number) {
    this.$set(this.form, "exclude_delegated", val);
    store.dispatch("user/addMeta", {
      [UserMetaKeys.UI_PRODUCTS_EXCLUDE_DELEGATES]: `${val}`
    });
  }
}
